export default "__VITE_ASSET__766ad392__"